import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { HolidayTypeDetailStateClass } from './interfaces/holidayTypeDetailStateClass';
import { sortData } from '../../../common/timeLiveFunction';

const initialState: HolidayTypeDetailStateClass = {
    isLoading: false,
    status: 'idle',
    holidayTypeDetailList: [],
    selectedRecord: {},
    isReload : false,
    MasterAccountHolidayTypeId: '',
    sortOrder: 'asc',
    sortColumn: 'HolidayName',
    search: '',
    pageNo: 1,
    pageSize: 10
}
interface IThunkApi {
    state: {
        holidayTypeDetail: HolidayTypeDetailStateClass;
    },
}


// export const getHolidaysAsync = createAsyncThunk
//     <any, void, IThunkApi>
//     (
//         'holidayTypeDetail/getHolidays',
//         async (arg, thunkApi) => {
//             const response = await fetchAPI('api/Holidays', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
//             const json = await response.json();
//             return json;
//         }
//     )
    export const getHolidaysDetailbyHolidayTypeIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'holidayTypeDetail/getHolidaysDetailbyHolidayTypeId',
        async (arg, thunkApi) => {
           
            const response = await fetchAPI('api/v2/Holidays/GetDataByAccountHolidayTypeId/'+ arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
    export const GetDataByAccountHolidayTypeIdAndYearAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'holidayTypeDetail/GetDataByAccountHolidayTypeIdAndYear',
        async (arg, thunkApi) => {
            const { AccountHolidayTypeId,HolidayYear } = arg;
            const response = await fetchAPI('api/v2/Holidays/GetDataByAccountHolidayTypeIdAndYear/'+ AccountHolidayTypeId + '/' + HolidayYear, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
    export const GetDataHolidaysNextYearByAccountHolidayTypeIdAndYearAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'holidayTypeDetail/GetDataHolidaysNextYearByAccountHolidayTypeIdAndYear',
        async (arg, thunkApi) => {
            const { AccountHolidayTypeId,HolidayYear } = arg;
          
            const response = await fetchAPI('api/v2/Holidays/GetDataHolidaysNextYearByAccountHolidayTypeIdAndYear/'+ AccountHolidayTypeId + '/' + HolidayYear, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
export const getHolidaysByIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'holidayTypeDetail/getHolidaysById',
        async (arg, thunkApi) => {
           
            const response = await fetchAPI('api/v2/Holidays/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    
    export const addHolidayTypeDetailAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'holidayTypeDetail/addHolidayTypeDetail',
        async (arg, thunkApi) => {
            console.log('Add Holiday Type :', arg);
            const response = await fetchAPI('api/v2/Holidays/', 'POST', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const updateHolidayTypeDetailAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'holidayTypeDetail/updateHolidayTypeDetail',
        async (arg, thunkApi) => {
            const { AccountHolidayTypeDetailId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/Holidays/' + AccountHolidayTypeDetailId, 'PUT', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const deleteHolidayTypeDetailAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'holidayTypeDetail/deleteHolidayTypeDetail',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Holidays/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const deleteAllSelectedRecordHolidayDetailAsync = createAsyncThunk
    <any,any,IThunkApi>
    (
        'holidayTypeDetail/deleteAllSelectedRecordHolidayDetailAsync',
        async(arg,thunkApi) =>{
           
            const response = await fetchAPI('api/v2/Holidays/DeleteAllSelectedRecordHolidayDetail/', 'DELETE', arg, true,'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json =await response.json();
            return json;
        
        }
    )
  
export const holidayTypeDetailSlice = createSlice({
    name: 'holidayType',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.holidayTypeDetailList.findIndex((item) => item.AccountHolidayTypeDetailId == action.payload);
            const newArray = [...state.holidayTypeDetailList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected : 1 };
            state.holidayTypeDetailList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.holidayTypeDetailList.findIndex((item) => item.AccountHolidayTypeDetailId == action.payload);
            const newArray = [...state.holidayTypeDetailList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.holidayTypeDetailList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.holidayTypeDetailList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.holidayTypeDetailList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.holidayTypeDetailList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.holidayTypeDetailList = newArray;
            //state.isAllUnChecked = true;
        },

        updateAccountHolidayTypeId: (state, action: PayloadAction<any>) => {
            state.MasterAccountHolidayTypeId = action.payload;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.holidayTypeDetailList;
            state.holidayTypeDetailList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }

    },
    extraReducers: (builder) => {
        builder
           
            .addCase(getHolidaysDetailbyHolidayTypeIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getHolidaysDetailbyHolidayTypeIdAsync.fulfilled, (state, { payload }) => {
               
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.holidayTypeDetailList = [];
                } else {
                    state.holidayTypeDetailList = payload.Data;
                    state.holidayTypeDetailList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
              
            })
            .addCase(getHolidaysDetailbyHolidayTypeIdAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(GetDataByAccountHolidayTypeIdAndYearAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GetDataByAccountHolidayTypeIdAndYearAsync.fulfilled, (state, { payload }) => {
                
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.holidayTypeDetailList = [];
                } else {
                    state.holidayTypeDetailList = payload.Data;
                    state.holidayTypeDetailList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.selectedRecord = {};
            })
            .addCase(GetDataByAccountHolidayTypeIdAndYearAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(GetDataHolidaysNextYearByAccountHolidayTypeIdAndYearAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GetDataHolidaysNextYearByAccountHolidayTypeIdAndYearAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                // state.holidayTypeDetailList = payload;
                if (Object.keys(payload).length === 0) {
                    state.holidayTypeDetailList = [];
                } else {
                    state.holidayTypeDetailList = payload;
                    state.holidayTypeDetailList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = true;
                state.selectedRecord = {};
            })
            .addCase(GetDataHolidaysNextYearByAccountHolidayTypeIdAndYearAsync.rejected, (state) => {
                state.status = 'failed';
            })
           .addCase(getHolidaysByIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getHolidaysByIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.selectedRecord = payload.Data[0];
               
            })
            .addCase(getHolidaysByIdAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(addHolidayTypeDetailAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addHolidayTypeDetailAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(addHolidayTypeDetailAsync.rejected, (state) => {
                state.status = 'failed';
            })
           
            .addCase(updateHolidayTypeDetailAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateHolidayTypeDetailAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(updateHolidayTypeDetailAsync.rejected, (state) => {
                state.status = 'failed';
            })
            
            .addCase(deleteHolidayTypeDetailAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteHolidayTypeDetailAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(deleteHolidayTypeDetailAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteAllSelectedRecordHolidayDetailAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAllSelectedRecordHolidayDetailAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                //state.holidayTypeDetailList = [];
            })
            .addCase(deleteAllSelectedRecordHolidayDetailAsync.rejected, (state) => {
                state.status = 'failed';
            })
    }
})
export const {
    resetSelectedRecordObjectInState,checkedState, unCheckedState, checkedAllState, unCheckedAllState,updateAccountHolidayTypeId,updatePagination,updateSorting
} = holidayTypeDetailSlice.actions
  export const holidayTypeDetailStateClass = (state: RootState) => state.holidayTypeDetail
 export default holidayTypeDetailSlice.reducer